// Shown instead of a silent empty list when the backend refuses or can't be
// reached. An empty list that looks like "nothing waiting" is the worst failure
// mode here: a stale REACT_APP_API_KEY baked into the build made every /api call
// answer 403 and the screens just showed zeros.
export default function LoadErrorBanner({ status, missingVars }) {
  // missingVars: names of API-key build variables that are empty in this build
  // (see apiKeyCheck.js). Shown instead of the HTTP-status cases below.
  const missing = Array.isArray(missingVars) && missingVars.length > 0;
  const rejected = status === 401 || status === 403;
  const headline = missing
    ? 'This build is missing its API key'
    : rejected
      ? 'Backend rejected credentials'
      : status === 'network'
        ? "Couldn't reach the backend"
        : `Backend returned an error (HTTP ${status})`;
  const detail = missing
    ? `${missingVars.join(' and ')} ${missingVars.length > 1 ? 'are' : 'is'} not set in this Scheduler build, so requests to the backend go out without a key and will fail. Set ${missingVars.length > 1 ? 'them' : 'it'} in the Cloudflare Pages project (Production) and redeploy.`
    : rejected
      ? `HTTP ${status}. The API key built into this Scheduler doesn't match the backend's key, so posts that are waiting are not being shown. Update REACT_APP_API_KEY in the Cloudflare Pages project to the backend's current key and redeploy.`
      : 'Posts that are waiting may exist but are not being shown. Try Refresh; if it keeps happening, check the backend.';
  return (
    <div role="alert" style={{ background: '#fef2f2', border: '1px solid #dc2626', borderRadius: 8, padding: '10px 12px', marginBottom: 12 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#b91c1c' }}>⚠ {headline}</div>
      <div style={{ fontSize: 12, color: '#7f1d1d', marginTop: 3, lineHeight: 1.45 }}>{detail}</div>
    </div>
  );
}
